import { IconProps } from "./IconProps";

export function ChevronDown(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </svg>
  );
}
